import { meltdownTiers } from "../meltdown_templates.js";
import { defineProceduralMap } from "./_helpers.js";

// A fully original template set (see meltdown_templates.js) built around
// mechanics the base game doesn't use — laser-gated doorways, stacked
// projectile crossfire, bullets fired across chasms, and spiked staircases —
// while keeping the same difficulty ramp and high/low chaining contract.
export const meltdownMap = defineProceduralMap({
  id: "meltdown",
  name: "Meltdown",
  description:
    "An all-new hazard course: timed laser gates, crossfire, and spiked climbs.",
  tiers: meltdownTiers,
});
